import React from 'react';
import { Box, Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

export function BarChart({
  chartCategory,
  chartSerieUp,
  chartSerieNoMon,
  chartSerieDown,
  title,
  isLoading,
}) {
  const { t } = useTranslation();
  if (isLoading) {
    return (
      <Box height={400} width="100%">
        <Skeleton
          height="100%"
          variant="rectangular"
          style={{
            backgroundColor: '#adadad',
          }}
        />
      </Box>
    );
  }

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={{
        chart: {
          type: 'bar',
          height: 400,
        },
        title: {
          text: title,
        },
        tooltip: {
          enabled: true,
          pointFormat: '<b>{point.y:.2f} (%)</b>',
        },
        xAxis: {
          categories: chartCategory,
          title: {
            text: t('sync.availability.chart.label.nodes'),
          },
          gridLineWidth: 1,
          lineWidth: 0,
        },
        yAxis: {
          max: 100,
          min: 0,
          title: {
            text: t('sync.availability.chart.label.availabilityPercent'),
          },
        },
        series: [
          {
            name: t('sync.availability.chart.label.uptime'),
            color: '#66d483',
            data: chartSerieUp,
          },
          {
            name: t('sync.availability.chart.label.downtime'),
            color: '#f2786f',
            data: chartSerieDown,
          },
          {
            name: t('sync.availability.chart.label.noMonitoring'),
            color: '#A9A9A9',
            data: chartSerieNoMon,
          },
        ],
        plotOptions: {
          series: {
            stacking: 'normal',
          },
        },
        credits: {
          enabled: false,
        },
      }}
    />
  );
}
